module.exports = __webpack_public_path__ + "img/icon_clear_mini.32f0c882.svg";